export const resolveColors = (theme, primitives) => {
  const deepReplace = (obj) =>
    Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key,
        typeof value === "object" && value !== null
          ? deepReplace(value)
          : primitives[value] || value,
      ])
    );

  return {
    ...theme,
    button: theme.button ? deepReplace(theme.button) : {},
  };
};
